export const officesStates = [
  {
    id: '03_loop',
    duration: 2100,
    loop: true,
    amountOfFrames: 45,
  },
];
